<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'ptoDetailDialog',
  mixins: [snackbarMixin],
  props: {
    isCreateMode: {
      type: Boolean,
    },
    item: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      visible: false,
      hasError: false,
      formData: {},
    };
  },
  computed: {
    ...mapGetters('ptoDetail', ['singularName']),
  },
  created() {
    this.formData = Object.assign({}, this.item);
  },
  mounted() {
    this.visible = true;
    this.initializeData();
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('personelIzin', ['getDetail', 'reject', 'approve']),
    ...mapMutations('personelIzin', ['getList']),
    fetchData() {
      this.isLoading = true;
      this.getDetail(this.formData.pfaaliyet)
        .then((data) => {
          this.item = data.data;
          this.isInitialized = true;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    rejectRecord(){	
      this.isLoading = true;	
      this.reject(this.formData.pfaaliyet)	
        .then(() => {	
          this.showSuccessMessage(`${this.formData.pfaaliyet} numaları personel izin talebi reddedilmiştir.`);	
          this.$emit('refresh');	
        })	
        .catch((err) => {	
          this.showErrorMessage(err.response && err.response.data);	
        })	
        .finally(() => {	
          this.isDeleting = false;	
          this.isLoading = false;	
          this.close();	
        });	
    },	
    approveRecord() {	
      this.isDeleting = true;	
      this.approve(this.formData.pfaaliyet)	
        .then(() => {	
          this.showSuccessMessage(`${this.formData.pfaaliyet} numaralı personel izin talebi onaylanmıştır.`);	
          this.$emit('refresh');	
        })	
        .catch((err) => {	
          this.showErrorMessage(err.response && err.response.data);	
        })	
        .finally(() => {	
          this.isDeleting = false;	
          this.isLoading = false;
          this.close();	
        });	
    },
    initializeData() {
      this.isLoading = true;
      Promise.all([this.getDetail(this.formData.pfaaliyet)])
        .then(([detail]) => {
          this.item = detail.data;
          this.isInitialized = true;
          this.isLoading = false;
        }, () => {
          this.hasError = true;
          this.isLoading = false;
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible" persistent max-width="1080px">
    <v-card>
      <v-card-title>
        {{item.personel}}
      </v-card-title>
      <v-flex xs12 style="margin-left:10px">
        {{ item.konu }}
        <br />
        {{ item.pozisyon }} - {{ item.santiyeAdi }}
      </v-flex>
      <div class="container" style="background-color:rgb(229 231 235)">
        <div class="row">
          <div class="col">
            <b>Açıklama:</b> {{ item.aciklama }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>İzin Türü:</b> {{ item.izinturu }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Personel Cari Hesaptan Kesilecek Mi:</b> {{ item.personelCariHesaptanKesilecekMi }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Başlangıç Tarihi:</b> {{ item.baslangicTarihi|dateTimeView  }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Bitiş Tarihi:</b> {{ item.bitisTarihi|dateTimeView }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>İşe Başlama Tarihi:</b> {{ item.personelIseBaslamaTarihi|dateTimeView  }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>İzin Gün Sayısı:</b> {{ item.gun }} Gün
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Adres:</b> {{ item.adres }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b>Telefon:</b> {{ item.telefon }}
          </div>
        </div>
      </div>

      <v-card-actions>
        <v-spacer />
        <v-btn :loading="isLoading" @click="rejectRecord" color="red lighten-3" dark>	
            Reddet	
        </v-btn>	
        <v-btn :loading="isLoading" @click="approveRecord" color="green lighten-3" dark>	
        Onayla	
        </v-btn>
        <v-btn color="red lighten-3" dark @click="close">
          Kapat
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
